<template>
  <v-container>
    <v-card class="mx-auto" max-width="800">
      <v-card-title class="text-h4">
        Тестирование ConfirmDialog
      </v-card-title>
      
      <v-card-text>
        <v-row>
          <!-- Базовые примеры -->
          <v-col cols="12">
            <h3 class="mb-3">Базовые диалоги</h3>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="primary" @click="testBasic">
              Простой диалог
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="success" @click="testSuccess">
              Успешное действие
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="warning" @click="testWarning">
              Предупреждение
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="error" @click="testDelete">
              Удаление
            </v-btn>
          </v-col>
          
          <!-- Дополнительные примеры -->
          <v-col cols="12" class="mt-5">
            <h3 class="mb-3">Специальные случаи</h3>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="info" @click="testInfo">
              Информация (без отмены)
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="purple" @click="testPayment">
              Подтверждение платежа
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="orange" @click="testHTML">
              С HTML содержимым
            </v-btn>
          </v-col>
          
          <v-col cols="12" md="6">
            <v-btn block color="teal" @click="testLongText">
              Длинный текст
            </v-btn>
          </v-col>

          <!-- Иконка сверху -->
          <v-col cols="12" class="mt-5">
            <h3 class="mb-3">Иконка сверху (центрированный стиль)</h3>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn block color="amber darken-2" @click="testIconTop">
              Иконка сверху (как на скрине)
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn block color="deep-purple" @click="testIconTopSuccess">
              Успех с иконкой сверху
            </v-btn>
          </v-col>

          <v-col cols="12" md="6">
            <v-btn block color="red darken-1" @click="testIconTopDelete">
              Удаление с иконкой сверху
            </v-btn>
          </v-col>
          
          <!-- Результат -->
          <v-col cols="12" class="mt-5">
            <v-alert
              v-if="lastResult !== null"
              :type="lastResult ? 'success' : 'info'"
              dismissible
              @input="lastResult = null"
            >
              <strong>Результат:</strong> 
              {{ lastResult ? 'Подтверждено ✓' : 'Отменено ✗' }}
            </v-alert>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<!-- для тестирования ConfirmDialog -->
<script>
export default {
  name: 'ConfirmDialogTest',
  
  data() {
    return {
      lastResult: null,
    };
  },
  
  methods: {
    async testBasic() {
      const result = await this.$confirm({
        title: "Простой диалог",
        text: "Это базовый пример диалога подтверждения",
      });
      this.lastResult = result;
    },
    
    async testSuccess() {
      const result = await this.$confirm({
        title: "Успешное действие",
        text: "Операция выполнена успешно!",
        icon: "mdi-check-circle-outline",
        iconColor: "success",
        confirmButtonText: "Отлично",
        showCancelButton: false,
      });
      this.lastResult = result;
    },
    
    async testWarning() {
      const result = await this.$confirm({
        title: "Предупреждение",
        text: "Вы уверены, что хотите продолжить?",
        icon: "mdi-alert-circle-outline",
        iconColor: "warning",
        confirmButtonText: "Да, продолжить",
        cancelButtonText: "Отмена",
      });
      this.lastResult = result;
    },
    
    async testDelete() {
      const result = await this.$confirm({
        title: "Удалить запись?",
        text: "Это действие нельзя будет отменить",
        icon: "mdi-delete-outline",
        iconColor: "error",
        confirmButtonText: "Удалить",
        confirmButtonColor: "error",
        cancelButtonText: "Отмена",
      });
      this.lastResult = result;
    },
    
    async testInfo() {
      const result = await this.$confirm({
        title: "Информация",
        text: "Это информационное сообщение без кнопки отмены",
        icon: "mdi-information-outline",
        iconColor: "info",
        showCancelButton: false,
        confirmButtonText: "Понятно",
      });
      this.lastResult = result;
    },
    
    async testPayment() {
      const amount = 1000;
      const currency = "RUB";
      
      const result = await this.$confirm({
        title: "Подтверждение платежа",
        text: `Вы собираетесь оплатить ${amount} ${currency}. Продолжить?`,
        icon: "mdi-credit-card-outline",
        iconColor: "success",
        confirmButtonText: "Оплатить",
        confirmButtonColor: "success",
        cancelButtonText: "Отмена",
      });
      this.lastResult = result;
      
      if (result) {
        this.$notify("Платеж успешен", "", "success");
      }
    },
    
    async testHTML() {
      const result = await this.$confirm({
        title: "Детали заказа",
        html: `
          <div style="text-align: left;">
            <p><strong>Товар:</strong> Premium подписка</p>
            <p><strong>Цена:</strong> 999 ₽</p>
            <p><strong>Срок:</strong> 1 месяц</p>
            <hr>
            <p><strong>Итого:</strong> 999 ₽</p>
          </div>
        `,
        icon: "mdi-receipt-text-outline",
        iconColor: "info",
        confirmButtonText: "Подтвердить",
        cancelButtonText: "Отмена",
        maxWidth: 600,
      });
      this.lastResult = result;
    },
    
    async testLongText() {
      const result = await this.$confirm({
        title: "Пользовательское соглашение",
        text: `
          Настоящее Пользовательское соглашение регулирует отношения между 
          Администрацией сайта и Пользователем данного сайта. Использование 
          Сайта означает безоговорочное согласие Пользователя с настоящим 
          Соглашением и указанными в нем условиями. В случае несогласия 
          Пользователя с данными условиями он должен воздержаться от 
          использования Сайта.
        `,
        icon: "mdi-file-document-outline",
        confirmButtonText: "Принимаю",
        confirmButtonColor: "success",
        cancelButtonText: "Отклоняю",
        maxWidth: 600,
      });
      this.lastResult = result;
    },

    // Примеры с иконкой сверху
    async testIconTop() {
      const result = await this.$confirm({
        title: "Вы уверены что хотите не вводить новый пробег?",
        text: "Если не ввести новый пробег, он перейдет к следующему клиенту, что нарушит расчет!",
        icon: "mdi-alert-outline",
        iconColor: "warning",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: "Да",
        confirmButtonColor: "primary",
        cancelButtonText: "Нет",
        cancelButtonColor: "grey darken-1",
        useFilledButtons: true,
        maxWidth: 450,
      });
      this.lastResult = result;
    },

    async testIconTopSuccess() {
      const result = await this.$confirm({
        title: "Операция выполнена успешно!",
        text: "Данные сохранены и обновлены",
        icon: "mdi-check-circle-outline",
        iconColor: "success",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: "Отлично",
        confirmButtonColor: "success",
        showCancelButton: false,
        useFilledButtons: true,
        maxWidth: 400,
      });
      this.lastResult = result;
    },

    async testIconTopDelete() {
      const result = await this.$confirm({
        title: "Удалить запись?",
        text: "Это действие нельзя будет отменить. Все связанные данные будут потеряны.",
        icon: "mdi-delete-alert-outline",
        iconColor: "error",
        iconSize: 72,
        iconPosition: "top",
        confirmButtonText: "Удалить",
        confirmButtonColor: "error",
        cancelButtonText: "Отмена",
        cancelButtonColor: "grey",
        useFilledButtons: true,
        maxWidth: 450,
      });
      this.lastResult = result;

      if (result) {
        this.$notify("Запись удалена", "", "success");
      }
    },
  },
};
</script>

<style scoped>
.v-btn {
  margin-bottom: 8px;
}
</style>

